var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "crm-page-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "crm-header-actions"
  }, [_c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.loadAll
    }
  }, [_vm._v(" Atualizar ")]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoFunil
    }
  }, [_vm._v(" Novo funil ")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.abrirModalPreConfiguracoes
    }
  }, [_vm._v(" Escolher pre-configuração ")]), _c('button', {
    staticClass: "btn btn-light-info btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingAtribuicoes
    },
    on: {
      "click": _vm.abrirModalAtribuicoes
    }
  }, [_vm._v(" Definir atribuições ")])])]), _c('b-tabs', {
    attrs: {
      "content-class": "mt-5",
      "nav-class": "crm-config-tabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Funis e etapas",
      "active": ""
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "card card-custom"
  }, [_c('div', {
    staticClass: "card-body text-muted"
  }, [_vm._v("Carregando configurações...")])]) : _c('b-row', [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Funis")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoFunil
    }
  }, [_vm._v(" Adicionar ")])]), _vm._l(_vm.funisOrdenados, function (funil) {
    return _c('button', {
      key: funil.id_crm_funil,
      staticClass: "crm-list-item",
      class: {
        active: funil.id_crm_funil === _vm.selectedFunilId
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.selectedFunilId = funil.id_crm_funil;
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(funil.nome))]), funil.descricao ? _c('small', [_vm._v(_vm._s(funil.descricao))]) : _vm._e()]), _c('span', {
      staticClass: "crm-badges"
    }, [funil.padrao ? _c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v("Padrão")]) : _vm._e(), !funil.ativo ? _c('b-badge', {
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("Inativo")]) : _vm._e()], 1)]);
  }), _vm.funisOrdenados.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_c('strong', [_vm._v("Nenhum funil cadastrado")]), _c('button', {
    staticClass: "btn btn-dark btn-sm mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoFunil
    }
  }, [_vm._v(" Criar funil ")])]) : _vm._e()], 2)]), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('div', [_c('h3', [_vm._v(" " + _vm._s(_vm.funilSelecionado ? _vm.funilSelecionado.nome : "Etapas") + " ")]), _vm.funilSelecionado ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Ordem, probabilidade e cor no Kanban ")]) : _vm._e()]), _vm.funilSelecionado ? _c('div', {
    staticClass: "crm-panel-actions"
  }, [_c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.editarFunil(_vm.funilSelecionado);
      }
    }
  }, [_vm._v(" Editar funil ")]), _c('button', {
    staticClass: "btn btn-light-danger btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.apagarFunil(_vm.funilSelecionado);
      }
    }
  }, [_vm._v(" Apagar funil ")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.novaEtapa(_vm.funilSelecionado);
      }
    }
  }, [_vm._v(" Nova etapa ")])]) : _vm._e()]), !_vm.funilSelecionado ? _c('div', {
    staticClass: "crm-empty"
  }, [_vm._v(" Selecione ou crie um funil. ")]) : _vm.etapasSelecionadas.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_c('strong', [_vm._v("Nenhuma etapa cadastrada")]), _c('button', {
    staticClass: "btn btn-dark btn-sm mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.novaEtapa(_vm.funilSelecionado);
      }
    }
  }, [_vm._v(" Criar etapa ")])]) : _c('div', {
    staticClass: "crm-stage-list"
  }, _vm._l(_vm.etapasSelecionadas, function (etapa) {
    return _c('div', {
      key: etapa.id_crm_etapa,
      staticClass: "crm-stage-row"
    }, [_c('span', {
      staticClass: "crm-color",
      style: {
        backgroundColor: etapa.cor || '#3699ff'
      }
    }), _c('div', {
      staticClass: "crm-stage-main"
    }, [_c('strong', [_vm._v(_vm._s(etapa.nome))]), _c('small', [_vm._v(" Ordem " + _vm._s(etapa.ordem || 0) + " · " + _vm._s(etapa.probabilidade || 0) + "% ")]), _vm.etapaAutomacaoResumo(etapa) ? _c('small', [_vm._v(" " + _vm._s(_vm.etapaAutomacaoResumo(etapa)) + " ")]) : _vm._e(), _vm.etapaCamposObrigatoriosResumo(etapa) ? _c('small', [_vm._v(" " + _vm._s(_vm.etapaCamposObrigatoriosResumo(etapa)) + " ")]) : _vm._e()]), _c('div', {
      staticClass: "crm-stage-actions"
    }, [_c('b-badge', {
      attrs: {
        "variant": etapa.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(etapa.ativo ? "Ativa" : "Inativa") + " ")]), _c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarEtapa(etapa);
        }
      }
    }, [_vm._v(" Editar ")])], 1)]);
  }), 0), _vm.funilSelecionado ? _c('div', {
    staticClass: "crm-access-box"
  }, [_c('div', {
    staticClass: "crm-access-header"
  }, [_c('div', [_c('h4', [_vm._v("Usuários com acesso")]), _c('small', [_vm._v(" Quem pode visualizar este funil. O gestor continua vendo todos os funis pela permissão de configuração. ")])]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.salvarAcessosFunil
    }
  }, [_vm._v(" Salvar acessos ")])]), _vm.usuarioOptionsSemTodos.length === 0 ? _c('div', {
    staticClass: "crm-empty compact"
  }, [_vm._v(" Nenhum usuário encontrado para configurar acesso. ")]) : _c('b-form-checkbox-group', {
    staticClass: "crm-access-options",
    attrs: {
      "options": _vm.usuarioOptionsSemTodos,
      "stacked": ""
    },
    model: {
      value: _vm.acessosFunilForm,
      callback: function callback($$v) {
        _vm.acessosFunilForm = $$v;
      },
      expression: "acessosFunilForm"
    }
  })], 1) : _vm._e()])])], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Fontes"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Fontes de oportunidade")]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novaFonte
    }
  }, [_vm._v(" Nova fonte ")])]), _vm.fontes.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_vm._v(" Nenhuma fonte cadastrada. Crie fontes para identificar de onde as oportunidades chegam. ")]) : _c('div', {
    staticClass: "crm-chip-grid"
  }, _vm._l(_vm.fontes, function (fonte) {
    return _c('button', {
      key: fonte.id_crm_fonte,
      staticClass: "crm-chip",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarFonte(fonte);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(fonte.nome))]), _c('b-badge', {
      attrs: {
        "variant": fonte.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(fonte.ativo ? "Ativa" : "Inativa") + " ")])], 1);
  }), 0)])]), _c('b-tab', {
    attrs: {
      "title": "Tipos de tarefa"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Tipos de tarefa")]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoTipoTarefa
    }
  }, [_vm._v(" Novo tipo ")])]), _vm.tiposTarefa.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_vm._v(" Nenhum tipo de tarefa cadastrado. Crie tipos para padronizar as próximas ações do time. ")]) : _c('div', {
    staticClass: "crm-chip-grid"
  }, _vm._l(_vm.tiposTarefa, function (tipo) {
    return _c('button', {
      key: tipo.id_crm_tipo_tarefa,
      staticClass: "crm-chip",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarTipoTarefa(tipo);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tipo.nome))]), _c('b-badge', {
      attrs: {
        "variant": tipo.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(tipo.ativo ? "Ativo" : "Inativo") + " ")])], 1);
  }), 0)])]), _c('b-tab', {
    attrs: {
      "title": "Temperaturas"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Temperaturas e qualificações")]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novaTemperatura
    }
  }, [_vm._v(" Nova temperatura ")])]), _vm.temperaturas.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_vm._v(" Nenhuma temperatura cadastrada. Crie qualificações para priorizar oportunidades no funil. ")]) : _c('div', {
    staticClass: "crm-chip-grid"
  }, _vm._l(_vm.temperaturas, function (temperatura) {
    return _c('button', {
      key: temperatura.id_crm_temperatura,
      staticClass: "crm-chip",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarTemperatura(temperatura);
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "crm-dot",
      style: {
        backgroundColor: temperatura.cor || '#3699ff'
      }
    }), _vm._v(" " + _vm._s(temperatura.nome) + " ")]), _c('span', {
      staticClass: "crm-badges"
    }, [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v("Peso " + _vm._s(temperatura.peso || 0))]), _c('b-badge', {
      attrs: {
        "variant": temperatura.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(temperatura.ativo ? "Ativa" : "Inativa") + " ")])], 1)]);
  }), 0)])]), _c('b-tab', {
    attrs: {
      "title": "Campos comerciais"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Campos comerciais opcionais")]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoCampoComercial
    }
  }, [_vm._v(" Novo campo ")])]), _vm.camposComerciais.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_vm._v(" Nenhum campo opcional cadastrado. Use campos comerciais para adaptar o CRM ao seu processo sem mexer no cadastro padrão. ")]) : _c('div', {
    staticClass: "crm-chip-grid"
  }, _vm._l(_vm.camposComerciais, function (campo) {
    return _c('button', {
      key: campo.id_crm_campo_comercial,
      staticClass: "crm-chip",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarCampoComercial(campo);
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(campo.nome))]), _c('small', [_vm._v(" " + _vm._s(_vm.tipoCampoLabel(campo.tipo)) + " · Ordem " + _vm._s(campo.ordem || 0) + " ")])]), _c('span', {
      staticClass: "crm-badges"
    }, [campo.obrigatorio ? _c('b-badge', {
      attrs: {
        "variant": "warning"
      }
    }, [_vm._v(" Obrigatório ")]) : _vm._e(), campo.visivel_kanban ? _c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(" Kanban ")]) : _vm._e(), _c('b-badge', {
      attrs: {
        "variant": campo.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(campo.ativo ? "Ativo" : "Inativo") + " ")])], 1)]);
  }), 0)])]), _c('b-tab', {
    attrs: {
      "title": "Automações"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('div', [_c('h3', [_vm._v("Automações")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Regras ativas e rascunhos")])]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novaAutomacao
    }
  }, [_vm._v(" Nova ")])]), _vm.automacoes.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_c('strong', [_vm._v("Nenhuma automação cadastrada")]), _c('span', [_vm._v("Crie regras para padronizar o fluxo comercial.")])]) : _vm._l(_vm.automacoes, function (automacao) {
    return _c('div', {
      key: automacao.id_crm_automacao,
      staticClass: "crm-list-item crm-list-item--automation",
      class: {
        active: automacao.id_crm_automacao === _vm.automacaoForm.id_crm_automacao
      }
    }, [_c('button', {
      staticClass: "crm-list-item-main",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarAutomacao(automacao);
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(automacao.nome))]), _c('small', [_vm._v(_vm._s(_vm.automacaoGatilhoResumo(automacao)))]), _c('small', [_vm._v(_vm._s(_vm.automacaoAcaoResumo(automacao)))]), _c('small', [_vm._v("Prioridade " + _vm._s(automacao.prioridade || 0))]), automacao.escopo === 'preset' ? _c('small', [_vm._v(" Regra do preset padrão ")]) : _vm._e(), automacao.ultima_execucao_em ? _c('small', [_vm._v(" Última execução: " + _vm._s(_vm.formatDateTime(automacao.ultima_execucao_em)) + " ")]) : _vm._e()])]), _c('div', {
      staticClass: "crm-automation-controls"
    }, [_c('span', {
      staticClass: "crm-badges"
    }, [automacao.escopo === 'preset' ? _c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v(" Preset ")]) : _vm._e(), _c('b-badge', {
      attrs: {
        "variant": automacao.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(automacao.ativo ? "Ativa" : "Inativa") + " ")])], 1), _c('div', {
      staticClass: "crm-automation-buttons"
    }, [_c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.saving
      },
      on: {
        "click": function click($event) {
          return _vm.editarAutomacao(automacao);
        }
      }
    }, [_vm._v(" Editar ")]), _c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.saving
      },
      on: {
        "click": function click($event) {
          return _vm.alternarStatusAutomacao(automacao);
        }
      }
    }, [_vm._v(" " + _vm._s(automacao.ativo ? "Inativar" : "Ativar") + " ")]), _c('button', {
      staticClass: "btn btn-light-danger btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.saving
      },
      on: {
        "click": function click($event) {
          return _vm.excluirAutomacao(automacao);
        }
      }
    }, [_vm._v(" Excluir ")])])])]);
  })], 2)]), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_c('div', {
    staticClass: "crm-panel mb-5"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('div', [_c('h3', [_vm._v(" " + _vm._s(_vm.automacaoForm.id_crm_automacao ? "Editar automação" : "Nova automação") + " ")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Gatilho, condições e ações simples ")])]), _c('b-badge', {
    attrs: {
      "variant": _vm.automacaoForm.ativo ? 'success' : 'secondary'
    }
  }, [_vm._v(" " + _vm._s(_vm.automacaoForm.ativo ? "Ativa" : "Inativa") + " ")])], 1), _c('b-alert', {
    staticClass: "crm-config-alert",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" As rotas desta aba usam a permissão "), _c('strong', [_vm._v("crm/configuracoes")]), _vm._v(". A simulação não altera oportunidades, tarefas ou timeline. ")]), _c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarAutomacao.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "120"
    },
    model: {
      value: _vm.automacaoForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.automacaoForm, "nome", $$v);
      },
      expression: "automacaoForm.nome"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Prioridade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.automacaoForm.prioridade,
      callback: function callback($$v) {
        _vm.$set(_vm.automacaoForm, "prioridade", _vm._n($$v));
      },
      expression: "automacaoForm.prioridade"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2"
    },
    model: {
      value: _vm.automacaoForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.automacaoForm, "descricao", $$v);
      },
      expression: "automacaoForm.descricao"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Gatilho"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.automacaoGatilhoOptions
    },
    model: {
      value: _vm.automacaoForm.gatilho,
      callback: function callback($$v) {
        _vm.$set(_vm.automacaoForm, "gatilho", $$v);
      },
      expression: "automacaoForm.gatilho"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Máx. execuções"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "10"
    },
    model: {
      value: _vm.automacaoForm.max_execucoes_por_evento,
      callback: function callback($$v) {
        _vm.$set(_vm.automacaoForm, "max_execucoes_por_evento", _vm._n($$v));
      },
      expression: "automacaoForm.max_execucoes_por_evento"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.automacaoForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.automacaoForm, "ativo", $$v);
      },
      expression: "automacaoForm.ativo"
    }
  }, [_vm._v(" Ativa ")])], 1)], 1), _c('div', {
    staticClass: "crm-builder-section"
  }, [_c('div', {
    staticClass: "crm-builder-title"
  }, [_c('h4', [_vm._v("Condições")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionarCondicao
    }
  }, [_vm._v(" Adicionar ")])]), _vm.automacaoForm.condicoes.length === 0 ? _c('div', {
    staticClass: "crm-empty compact"
  }, [_vm._v(" Sem condições. A automação roda para qualquer evento deste gatilho. ")]) : _vm._e(), _vm._l(_vm.automacaoForm.condicoes, function (condicao, index) {
    return _c('div', {
      key: "condicao-".concat(index),
      staticClass: "crm-builder-row"
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoCondicaoOptions
      },
      model: {
        value: condicao.campo,
        callback: function callback($$v) {
          _vm.$set(condicao, "campo", $$v);
        },
        expression: "condicao.campo"
      }
    }), _c('b-form-select', {
      attrs: {
        "options": _vm.automacaoOperadorOptions
      },
      model: {
        value: condicao.operador,
        callback: function callback($$v) {
          _vm.$set(condicao, "operador", $$v);
        },
        expression: "condicao.operador"
      }
    }), _c('b-form-input', {
      attrs: {
        "placeholder": "Valor esperado"
      },
      model: {
        value: condicao.valor,
        callback: function callback($$v) {
          _vm.$set(condicao, "valor", $$v);
        },
        expression: "condicao.valor"
      }
    }), _c('button', {
      staticClass: "btn btn-light-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removerCondicao(index);
        }
      }
    }, [_vm._v(" Remover ")])], 1);
  })], 2), _c('div', {
    staticClass: "crm-builder-section"
  }, [_c('div', {
    staticClass: "crm-builder-title"
  }, [_c('h4', [_vm._v("Ações")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionarAcao
    }
  }, [_vm._v(" Adicionar ")])]), _vm._l(_vm.automacaoForm.acoes, function (acao, index) {
    return _c('div', {
      key: "acao-".concat(index),
      staticClass: "crm-action-builder"
    }, [_c('div', {
      staticClass: "crm-builder-row"
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoAcaoOptions
      },
      on: {
        "change": function change($event) {
          return _vm.aoAlterarAcao(acao);
        }
      },
      model: {
        value: acao.acao,
        callback: function callback($$v) {
          _vm.$set(acao, "acao", $$v);
        },
        expression: "acao.acao"
      }
    }), _c('button', {
      staticClass: "btn btn-light-danger btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.automacaoForm.acoes.length === 1
      },
      on: {
        "click": function click($event) {
          return _vm.removerAcao(index);
        }
      }
    }, [_vm._v(" Remover ")])], 1), _c('div', {
      staticClass: "crm-automation-editor"
    }, [_vm.acaoTemDestino(acao) ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Destino do fluxo")]), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Funil de destino"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoFunilOptionsComVazio
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.id_crm_funil_destino,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_crm_funil_destino", $$v);
        },
        expression: "acao.parametros.id_crm_funil_destino"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Etapa de destino"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoEtapaOptionsPorFunil(acao.parametros.id_crm_funil_destino)
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.id_crm_etapa_destino,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_crm_etapa_destino", $$v);
        },
        expression: "acao.parametros.id_crm_etapa_destino"
      }
    })], 1)], 1)], 1)], 1) : _vm._e(), _vm.acaoTemAtribuicao(acao) ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Atribuir card")]), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": _vm.labelAtribuicaoAcao(acao)
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoUsuarioOptionsComVazio
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.id_usuario_tecnico,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_usuario_tecnico", $$v);
        },
        expression: "acao.parametros.id_usuario_tecnico"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Regra de responsável"
      }
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "Ex.: tecnico_apresentacao"
      },
      on: {
        "input": function input($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.responsavel,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "responsavel", $$v);
        },
        expression: "acao.parametros.responsavel"
      }
    })], 1)], 1)], 1), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" Isso define quem recebe ou passa a operar o card. O acesso ao funil é configurado separadamente abaixo. ")])], 1) : _vm._e(), acao.acao === 'alterar_responsavel' ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Atribuir card")]), _c('b-form-group', {
      attrs: {
        "label": "Novo responsável"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoUsuarioOptionsComVazio
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.id_usuario,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_usuario", $$v);
        },
        expression: "acao.parametros.id_usuario"
      }
    })], 1)], 1) : _vm._e(), _vm.acaoTemLiberacaoFunil(acao) ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Liberar funil")]), _c('b-form-checkbox', {
      staticClass: "mb-3",
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.conceder_acesso_funil_tecnico,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "conceder_acesso_funil_tecnico", $$v);
        },
        expression: "\n                          acao.parametros.conceder_acesso_funil_tecnico\n                        "
      }
    }, [_vm._v(" Dar acesso ao funil para o usuário definido na regra ")]), _c('b-form-group', {
      attrs: {
        "label": "Funil liberado"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoFunilOptionsComVazio
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.id_crm_funil_tecnico,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_crm_funil_tecnico", $$v);
        },
        expression: "acao.parametros.id_crm_funil_tecnico"
      }
    })], 1)], 1) : _vm._e(), acao.acao === 'exigir_campo_antes_mover' ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Campo obrigatório")]), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "5"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Campo"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoCampoOptionsComVazio
      },
      on: {
        "change": function change($event) {
          return _vm.sincronizarCampoObrigatorioAcao(acao);
        }
      },
      model: {
        value: acao.parametros.id_crm_campo_comercial,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_crm_campo_comercial", $$v);
        },
        expression: "acao.parametros.id_crm_campo_comercial"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "7"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Mensagem"
      }
    }, [_c('b-form-input', {
      on: {
        "input": function input($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.mensagem,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "mensagem", $$v);
        },
        expression: "acao.parametros.mensagem"
      }
    })], 1)], 1)], 1)], 1) : _vm._e(), acao.acao === 'criar_tarefa' ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Tarefa criada")]), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "5"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Título"
      }
    }, [_c('b-form-input', {
      on: {
        "input": function input($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.titulo,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "titulo", $$v);
        },
        expression: "acao.parametros.titulo"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Tipo"
      }
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "ligacao, tarefa..."
      },
      on: {
        "input": function input($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.tipo_tarefa,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "tipo_tarefa", $$v);
        },
        expression: "acao.parametros.tipo_tarefa"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Responsável"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoUsuarioOptionsComVazio
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.id_usuario,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_usuario", $$v);
        },
        expression: "acao.parametros.id_usuario"
      }
    })], 1)], 1)], 1)], 1) : _vm._e(), acao.acao === 'atualizar_cliente' ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Dados obrigatórios")]), _c('b-form-group', {
      attrs: {
        "label": "Campos obrigatórios para salvar cliente",
        "description": "Separe chaves por vírgula. Ex.: cnpj, email_cliente, endereco_cliente"
      }
    }, [_c('b-form-input', {
      on: {
        "input": function input($event) {
          return _vm.atualizarCamposObrigatoriosAcao(acao);
        }
      },
      model: {
        value: acao.parametros.campos_obrigatorios_texto,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "campos_obrigatorios_texto", $$v);
        },
        expression: "acao.parametros.campos_obrigatorios_texto"
      }
    })], 1)], 1) : _vm._e(), acao.acao === 'enviar_link_agenda' ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Agenda por link")]), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "7"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Tipo da tarefa"
      }
    }, [_c('b-form-input', {
      on: {
        "input": function input($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.tipo_tarefa,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "tipo_tarefa", $$v);
        },
        expression: "acao.parametros.tipo_tarefa"
      }
    })], 1)], 1), _c('b-col', {
      staticClass: "d-flex align-items-center",
      attrs: {
        "md": "5"
      }
    }, [_c('b-form-checkbox', {
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.obrigatorio_para_concluir,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "obrigatorio_para_concluir", $$v);
        },
        expression: "\n                              acao.parametros.obrigatorio_para_concluir\n                            "
      }
    }, [_vm._v(" Obrigatório para concluir ")])], 1)], 1)], 1) : _vm._e(), acao.acao === 'criar_timeline' || acao.acao === 'notificar_usuario' ? _c('div', {
      staticClass: "crm-action-box"
    }, [_c('div', {
      staticClass: "crm-action-label"
    }, [_vm._v("Mensagem")]), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "8"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Descrição"
      }
    }, [_c('b-form-input', {
      on: {
        "input": function input($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.descricao,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "descricao", $$v);
        },
        expression: "acao.parametros.descricao"
      }
    })], 1)], 1), acao.acao === 'notificar_usuario' ? _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Usuário"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.automacaoUsuarioOptionsComVazio
      },
      on: {
        "change": function change($event) {
          return _vm.atualizarParametrosTexto(acao);
        }
      },
      model: {
        value: acao.parametros.id_usuario,
        callback: function callback($$v) {
          _vm.$set(acao.parametros, "id_usuario", $$v);
        },
        expression: "acao.parametros.id_usuario"
      }
    })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('details', {
      staticClass: "crm-advanced-json"
    }, [_c('summary', [_vm._v("JSON avançado")]), _c('b-form-textarea', {
      attrs: {
        "rows": "3"
      },
      on: {
        "blur": function blur($event) {
          return _vm.sincronizarParametrosTexto(acao, true);
        }
      },
      model: {
        value: acao.parametros_texto,
        callback: function callback($$v) {
          _vm.$set(acao, "parametros_texto", $$v);
        },
        expression: "acao.parametros_texto"
      }
    })], 1)])]);
  })], 2), _c('div', {
    staticClass: "crm-builder-footer"
  }, [_c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novaAutomacao
    }
  }, [_vm._v(" Limpar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar automação ")])])], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "crm-panel h-100"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Simular")])]), _c('b-form-group', {
    attrs: {
      "label": "ID da oportunidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: _vm.automacaoSimulacao.id_crm_oportunidade,
      callback: function callback($$v) {
        _vm.$set(_vm.automacaoSimulacao, "id_crm_oportunidade", _vm._n($$v));
      },
      expression: "automacaoSimulacao.id_crm_oportunidade"
    }
  })], 1), _c('button', {
    staticClass: "btn btn-light-primary btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.automacaoForm.gatilho
    },
    on: {
      "click": _vm.simularAutomacao
    }
  }, [_vm._v(" Simular gatilho ")]), _vm.automacaoSimulacao.resultado ? _c('div', {
    staticClass: "crm-simulation-result"
  }, [_c('strong', [_vm._v("Resultado")]), _c('small', [_vm._v(" Executadas: " + _vm._s(_vm.automacaoSimulacao.resultado.executadas || 0) + " · Ignoradas: " + _vm._s(_vm.automacaoSimulacao.resultado.ignoradas || 0) + " ")])]) : _vm._e()], 1)]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "crm-panel h-100"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Histórico de execuções")]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadAutomacaoExecucoes
    }
  }, [_vm._v(" Atualizar ")])]), _vm.automacaoExecucoes.length === 0 ? _c('div', {
    staticClass: "crm-empty compact"
  }, [_vm._v(" Nenhuma execução registrada. ")]) : _c('div', {
    staticClass: "crm-execution-list"
  }, _vm._l(_vm.automacaoExecucoes, function (execucao) {
    return _c('div', {
      key: execucao.id_crm_automacao_execucao,
      staticClass: "crm-execution-row"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(execucao.automacao || "Automação"))]), _c('small', [_vm._v(" " + _vm._s(_vm.automacaoGatilhoLabel(execucao.gatilho)) + " · " + _vm._s(_vm.formatDateTime(execucao.created_at)) + " ")]), execucao.erro ? _c('small', [_vm._v(_vm._s(execucao.erro))]) : _vm._e()]), _c('b-badge', {
      attrs: {
        "variant": _vm.execucaoStatusVariant(execucao.status)
      }
    }, [_vm._v(" " + _vm._s(execucao.status) + " ")])], 1);
  }), 0)])])], 1)], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Motivos de perda"
    }
  }, [_c('div', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Motivos de perda")]), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoMotivo
    }
  }, [_vm._v(" Novo motivo ")])]), _vm.motivos.length === 0 ? _c('div', {
    staticClass: "crm-empty"
  }, [_vm._v(" Nenhum motivo cadastrado. Crie motivos para entender por que oportunidades são perdidas. ")]) : _c('div', {
    staticClass: "crm-chip-grid"
  }, _vm._l(_vm.motivos, function (motivo) {
    return _c('button', {
      key: motivo.id_crm_motivo_perda,
      staticClass: "crm-chip",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarMotivo(motivo);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(motivo.nome))]), _c('b-badge', {
      attrs: {
        "variant": motivo.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(motivo.ativo ? "Ativo" : "Inativo") + " ")])], 1);
  }), 0)])])], 1), _c('b-modal', {
    attrs: {
      "title": "Escolher pre-configuração",
      "size": "lg",
      "hide-footer": "",
      "modal-class": "crm-presets-modal"
    },
    model: {
      value: _vm.modalPreConfiguracoes,
      callback: function callback($$v) {
        _vm.modalPreConfiguracoes = $$v;
      },
      expression: "modalPreConfiguracoes"
    }
  }, [_c('div', {
    staticClass: "crm-presets"
  }, [_c('div', {
    staticClass: "crm-assignments-intro"
  }, [_c('div', [_c('strong', [_vm._v("Pré-configurações CRM")]), _c('span', [_vm._v(" Escolha um modelo para instalar ou atualizar sem apagar os funis que já existem. ")])]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingPreConfiguracoes
    },
    on: {
      "click": _vm.loadPreConfiguracoes
    }
  }, [_vm._v(" Atualizar ")])]), _vm.loadingPreConfiguracoes ? _c('div', {
    staticClass: "crm-empty compact"
  }, [_vm._v(" Carregando pré-configurações... ")]) : _c('div', {
    staticClass: "crm-presets-grid"
  }, _vm._l(_vm.preConfiguracoes, function (preset) {
    return _c('section', {
      key: preset.chave,
      staticClass: "crm-preset-card"
    }, [_c('div', {
      staticClass: "crm-preset-card__header"
    }, [_c('div', [_c('h4', [_vm._v(_vm._s(preset.nome))]), _c('p', [_vm._v(_vm._s(preset.descricao))])]), _c('b-badge', {
      attrs: {
        "variant": _vm.variantStatusPreConfiguracao(preset)
      }
    }, [_vm._v(" " + _vm._s(_vm.labelStatusPreConfiguracao(preset)) + " ")])], 1), _c('ul', _vm._l(preset.itens || [], function (item) {
      return _c('li', {
        key: item
      }, [_vm._v(" " + _vm._s(item) + " ")]);
    }), 0), _c('button', {
      staticClass: "btn btn-dark btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.saving || preset.status_instalacao === 'instalado'
      },
      on: {
        "click": function click($event) {
          return _vm.instalarPreConfiguracao(preset);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.labelAcaoPreConfiguracao(preset)) + " ")])]);
  }), 0), _c('div', {
    staticClass: "crm-modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.modalPreConfiguracoes = false;
      }
    }
  }, [_vm._v(" Fechar ")])])])]), _c('b-modal', {
    attrs: {
      "title": "Definir atribuições",
      "size": "xl",
      "hide-footer": "",
      "modal-class": "crm-assignments-modal"
    },
    model: {
      value: _vm.modalAtribuicoes,
      callback: function callback($$v) {
        _vm.modalAtribuicoes = $$v;
      },
      expression: "modalAtribuicoes"
    }
  }, [_c('div', {
    staticClass: "crm-assignments"
  }, [_c('div', {
    staticClass: "crm-assignments-intro"
  }, [_c('div', [_c('strong', [_vm._v("Preset software-house")]), _c('span', [_vm._v(" Escolha quem atua em cada papel. Um usuário pode aparecer em mais de uma atribuição. ")])]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingAtribuicoes
    },
    on: {
      "click": _vm.loadAtribuicoes
    }
  }, [_vm._v(" Atualizar ")])]), _vm.loadingAtribuicoes ? _c('div', {
    staticClass: "crm-empty compact"
  }, [_vm._v(" Carregando atribuições... ")]) : _vm.usuarioAtribuicaoOptions.length === 0 ? _c('div', {
    staticClass: "crm-empty compact"
  }, [_vm._v(" Nenhum usuário ativo encontrado para atribuir ao CRM. ")]) : _c('div', {
    staticClass: "crm-role-grid"
  }, _vm._l(_vm.atribuicaoPapeis, function (papel) {
    return _c('section', {
      key: papel.chave,
      staticClass: "crm-role-section"
    }, [_c('div', {
      staticClass: "crm-role-header"
    }, [_c('h4', [_vm._v(_vm._s(papel.nome))]), _c('small', [_vm._v(_vm._s(papel.descricao))])]), _c('b-form-checkbox-group', {
      staticClass: "crm-role-checks",
      attrs: {
        "options": _vm.usuarioAtribuicaoOptions,
        "disabled": _vm.saving,
        "stacked": ""
      },
      model: {
        value: _vm.atribuicoesForm[papel.chave],
        callback: function callback($$v) {
          _vm.$set(_vm.atribuicoesForm, papel.chave, $$v);
        },
        expression: "atribuicoesForm[papel.chave]"
      }
    })], 1);
  }), 0), _c('div', {
    staticClass: "crm-modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.modalAtribuicoes = false;
      }
    }
  }, [_vm._v(" Fechar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.loadingAtribuicoes
    },
    on: {
      "click": _vm.salvarAtribuicoes
    }
  }, [_vm._v(" Salvar atribuições ")])])])]), _c('b-modal', {
    attrs: {
      "title": _vm.funilForm.id_crm_funil ? 'Editar funil' : 'Novo funil',
      "hide-footer": ""
    },
    model: {
      value: _vm.modalFunil,
      callback: function callback($$v) {
        _vm.modalFunil = $$v;
      },
      expression: "modalFunil"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarFunil.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": ""
    },
    model: {
      value: _vm.funilForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.funilForm, "nome", $$v);
      },
      expression: "funilForm.nome"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "maxlength": "255"
    },
    model: {
      value: _vm.funilForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.funilForm, "descricao", $$v);
      },
      expression: "funilForm.descricao"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ordem"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.funilForm.ordem,
      callback: function callback($$v) {
        _vm.$set(_vm.funilForm, "ordem", _vm._n($$v));
      },
      expression: "funilForm.ordem"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mr-4",
    model: {
      value: _vm.funilForm.padrao,
      callback: function callback($$v) {
        _vm.$set(_vm.funilForm, "padrao", $$v);
      },
      expression: "funilForm.padrao"
    }
  }, [_vm._v(" Funil padrão ")]), _c('b-form-checkbox', {
    model: {
      value: _vm.funilForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.funilForm, "ativo", $$v);
      },
      expression: "funilForm.ativo"
    }
  }, [_vm._v(" Ativo ")])], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.modalFunil = false;
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1), _c('b-modal', {
    attrs: {
      "title": _vm.etapaForm.id_crm_etapa ? 'Editar etapa' : 'Nova etapa',
      "hide-footer": ""
    },
    model: {
      value: _vm.modalEtapa,
      callback: function callback($$v) {
        _vm.modalEtapa = $$v;
      },
      expression: "modalEtapa"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarEtapa.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Funil"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.funilOptions
    },
    model: {
      value: _vm.etapaForm.id_crm_funil,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "id_crm_funil", $$v);
      },
      expression: "etapaForm.id_crm_funil"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "80",
      "autofocus": ""
    },
    model: {
      value: _vm.etapaForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "nome", $$v);
      },
      expression: "etapaForm.nome"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ordem"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.etapaForm.ordem,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "ordem", _vm._n($$v));
      },
      expression: "etapaForm.ordem"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Probabilidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    model: {
      value: _vm.etapaForm.probabilidade,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "probabilidade", _vm._n($$v));
      },
      expression: "etapaForm.probabilidade"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cor"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "color"
    },
    model: {
      value: _vm.etapaForm.cor,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "cor", $$v);
      },
      expression: "etapaForm.cor"
    }
  })], 1)], 1)], 1), _c('b-form-checkbox', {
    staticClass: "mb-5",
    model: {
      value: _vm.etapaForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "ativo", $$v);
      },
      expression: "etapaForm.ativo"
    }
  }, [_vm._v(" Ativa ")]), _c('div', {
    staticClass: "crm-automation-box mb-5"
  }, [_c('h4', [_vm._v("Automação simples")]), _c('b-form-checkbox', {
    staticClass: "mb-3",
    model: {
      value: _vm.etapaForm.sugerir_tarefa,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "sugerir_tarefa", $$v);
      },
      expression: "etapaForm.sugerir_tarefa"
    }
  }, [_vm._v(" Sugerir tarefa ao mover oportunidade para esta etapa ")]), _vm.etapaForm.sugerir_tarefa ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo da tarefa"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoTarefaOptions
    },
    model: {
      value: _vm.etapaForm.tarefa_sugerida_tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "tarefa_sugerida_tipo", $$v);
      },
      expression: "etapaForm.tarefa_sugerida_tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Prazo em horas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.etapaForm.tarefa_sugerida_prazo_horas,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "tarefa_sugerida_prazo_horas", _vm._n($$v));
      },
      expression: "etapaForm.tarefa_sugerida_prazo_horas"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.etapaForm.sugerir_tarefa ? _c('b-form-group', {
    attrs: {
      "label": "Título sugerido"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "140",
      "placeholder": "Ex.: Fazer follow-up com o cliente"
    },
    model: {
      value: _vm.etapaForm.tarefa_sugerida_titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "tarefa_sugerida_titulo", $$v);
      },
      expression: "etapaForm.tarefa_sugerida_titulo"
    }
  })], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.etapaForm.exigir_motivo_perda,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "exigir_motivo_perda", $$v);
      },
      expression: "etapaForm.exigir_motivo_perda"
    }
  }, [_vm._v(" Exigir motivo ao perder nesta etapa ")])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.etapaForm.destacar_sem_tarefa,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "destacar_sem_tarefa", $$v);
      },
      expression: "etapaForm.destacar_sem_tarefa"
    }
  }, [_vm._v(" Destacar oportunidade sem tarefa ")])], 1)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.etapaForm.alertar_oportunidade_parada,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "alertar_oportunidade_parada", $$v);
      },
      expression: "etapaForm.alertar_oportunidade_parada"
    }
  }, [_vm._v(" Alertar oportunidade parada ")])], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Dias sem movimento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: _vm.etapaForm.alerta_parada_dias,
      callback: function callback($$v) {
        _vm.$set(_vm.etapaForm, "alerta_parada_dias", _vm._n($$v));
      },
      expression: "etapaForm.alerta_parada_dias"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.modalEtapa = false;
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1), _c('b-modal', {
    attrs: {
      "title": _vm.fonteForm.id_crm_fonte ? 'Editar fonte' : 'Nova fonte',
      "hide-footer": ""
    },
    model: {
      value: _vm.modalFonte,
      callback: function callback($$v) {
        _vm.modalFonte = $$v;
      },
      expression: "modalFonte"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarFonte.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": ""
    },
    model: {
      value: _vm.fonteForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.fonteForm, "nome", $$v);
      },
      expression: "fonteForm.nome"
    }
  })], 1), _c('b-form-checkbox', {
    staticClass: "mb-5",
    model: {
      value: _vm.fonteForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.fonteForm, "ativo", $$v);
      },
      expression: "fonteForm.ativo"
    }
  }, [_vm._v(" Ativa ")]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.modalFonte = false;
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1), _c('b-modal', {
    attrs: {
      "title": _vm.motivoForm.id_crm_motivo_perda ? 'Editar motivo' : 'Novo motivo',
      "hide-footer": ""
    },
    model: {
      value: _vm.modalMotivo,
      callback: function callback($$v) {
        _vm.modalMotivo = $$v;
      },
      expression: "modalMotivo"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarMotivo.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": ""
    },
    model: {
      value: _vm.motivoForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.motivoForm, "nome", $$v);
      },
      expression: "motivoForm.nome"
    }
  })], 1), _c('b-form-checkbox', {
    staticClass: "mb-5",
    model: {
      value: _vm.motivoForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.motivoForm, "ativo", $$v);
      },
      expression: "motivoForm.ativo"
    }
  }, [_vm._v(" Ativo ")]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.modalMotivo = false;
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1), _c('b-modal', {
    attrs: {
      "title": _vm.tipoTarefaForm.id_crm_tipo_tarefa ? 'Editar tipo de tarefa' : 'Novo tipo de tarefa',
      "hide-footer": ""
    },
    model: {
      value: _vm.modalTipoTarefa,
      callback: function callback($$v) {
        _vm.modalTipoTarefa = $$v;
      },
      expression: "modalTipoTarefa"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarTipoTarefa.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": ""
    },
    model: {
      value: _vm.tipoTarefaForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.tipoTarefaForm, "nome", $$v);
      },
      expression: "tipoTarefaForm.nome"
    }
  })], 1), _c('b-form-checkbox', {
    staticClass: "mb-5",
    model: {
      value: _vm.tipoTarefaForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.tipoTarefaForm, "ativo", $$v);
      },
      expression: "tipoTarefaForm.ativo"
    }
  }, [_vm._v(" Ativo ")]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.modalTipoTarefa = false;
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1), _c('b-modal', {
    attrs: {
      "title": _vm.temperaturaForm.id_crm_temperatura ? 'Editar temperatura' : 'Nova temperatura',
      "hide-footer": ""
    },
    model: {
      value: _vm.modalTemperatura,
      callback: function callback($$v) {
        _vm.modalTemperatura = $$v;
      },
      expression: "modalTemperatura"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarTemperatura.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "80",
      "autofocus": ""
    },
    model: {
      value: _vm.temperaturaForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.temperaturaForm, "nome", $$v);
      },
      expression: "temperaturaForm.nome"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cor"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "color"
    },
    model: {
      value: _vm.temperaturaForm.cor,
      callback: function callback($$v) {
        _vm.$set(_vm.temperaturaForm, "cor", $$v);
      },
      expression: "temperaturaForm.cor"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Peso"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: _vm.temperaturaForm.peso,
      callback: function callback($$v) {
        _vm.$set(_vm.temperaturaForm, "peso", _vm._n($$v));
      },
      expression: "temperaturaForm.peso"
    }
  })], 1)], 1)], 1), _c('b-form-checkbox', {
    staticClass: "mb-5",
    model: {
      value: _vm.temperaturaForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.temperaturaForm, "ativo", $$v);
      },
      expression: "temperaturaForm.ativo"
    }
  }, [_vm._v(" Ativa ")]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.modalTemperatura = false;
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1), _c('b-modal', {
    attrs: {
      "title": _vm.campoComercialForm.id_crm_campo_comercial ? 'Editar campo comercial' : 'Novo campo comercial',
      "hide-footer": ""
    },
    model: {
      value: _vm.modalCampoComercial,
      callback: function callback($$v) {
        _vm.modalCampoComercial = $$v;
      },
      expression: "modalCampoComercial"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvarCampoComercial.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": ""
    },
    model: {
      value: _vm.campoComercialForm.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.campoComercialForm, "nome", $$v);
      },
      expression: "campoComercialForm.nome"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoCampoOptions
    },
    model: {
      value: _vm.campoComercialForm.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.campoComercialForm, "tipo", $$v);
      },
      expression: "campoComercialForm.tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ordem"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.campoComercialForm.ordem,
      callback: function callback($$v) {
        _vm.$set(_vm.campoComercialForm, "ordem", _vm._n($$v));
      },
      expression: "campoComercialForm.ordem"
    }
  })], 1)], 1)], 1), _vm.campoComercialForm.tipo === 'lista' ? _c('b-form-group', {
    attrs: {
      "label": "Opções"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3",
      "placeholder": "Uma opção por linha"
    },
    model: {
      value: _vm.campoComercialForm.opcoes,
      callback: function callback($$v) {
        _vm.$set(_vm.campoComercialForm, "opcoes", $$v);
      },
      expression: "campoComercialForm.opcoes"
    }
  })], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.campoComercialForm.obrigatorio,
      callback: function callback($$v) {
        _vm.$set(_vm.campoComercialForm, "obrigatorio", $$v);
      },
      expression: "campoComercialForm.obrigatorio"
    }
  }, [_vm._v(" Obrigatório ")])], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.campoComercialForm.visivel_kanban,
      callback: function callback($$v) {
        _vm.$set(_vm.campoComercialForm, "visivel_kanban", $$v);
      },
      expression: "campoComercialForm.visivel_kanban"
    }
  }, [_vm._v(" Kanban ")])], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.campoComercialForm.ativo,
      callback: function callback($$v) {
        _vm.$set(_vm.campoComercialForm, "ativo", $$v);
      },
      expression: "campoComercialForm.ativo"
    }
  }, [_vm._v(" Ativo ")])], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end mt-5"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.modalCampoComercial = false;
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h2', {
    staticClass: "font-weight-bolder mb-1"
  }, [_vm._v("Configurações CRM")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Funis, etapas, automações, campos comerciais e cadastros auxiliares ")])]);
}];
export { render, staticRenderFns };